var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Message/Active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message/Active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1337891,38.5224609 C30.1591797,38.5224609 30.7304688,37.7900391 30.7304688,36.6621094 L30.7304688,32.8535156 L31.4335938,32.8535156 C35.7988281,32.8535156 38.1425781,30.4511719 38.1425781,26.1445312 L38.1425781,14.9238281 C38.1425781,10.6171875 35.7988281,8.21484375 31.4335938,8.21484375 L12.5664062,8.21484375 C8.20117188,8.21484375 5.85742188,10.6318359 5.85742188,14.9238281 L5.85742188,26.1445312 C5.85742188,30.4365234 8.20117188,32.8535156 12.5664062,32.8535156 L21.9707031,32.8535156 L27.0244141,37.3505859 C27.9179688,38.1416016 28.4160156,38.5224609 29.1337891,38.5224609 Z M28.5332031,35.8417969 L23.8457031,31.1835938 C23.2890625,30.6123047 22.8789062,30.4951172 22.0585938,30.4951172 L12.5664062,30.4951172 C9.62207031,30.4951172 8.21582031,28.9863281 8.21582031,26.1298828 L8.21582031,14.9238281 C8.21582031,12.0673828 9.62207031,10.5732422 12.5664062,10.5732422 L31.4335938,10.5732422 C34.3925781,10.5732422 35.7841797,12.0673828 35.7841797,14.9238281 L35.7841797,26.1298828 C35.7841797,28.9863281 34.3925781,30.4951172 31.4335938,30.4951172 L29.6318359,30.4951172 C28.8408203,30.4951172 28.5332031,30.8027344 28.5332031,31.59375 L28.5332031,35.8417969 Z",
    id: "Active",
    fill: "#40515D",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon_message.fbdf1f04.svg";
export { ForwardRef as ReactComponent };